import { Code2, Mail } from 'lucide-react'

const columns = [
  {
    title: 'Product',
    links: [
      { label: 'Download', href: '/downloads' },
      { label: 'Why NewEmail', href: '/#features' },
      { label: 'Getting started', href: '/docs' },
      { label: 'FAQ', href: '/faq' },
    ],
  },
  {
    title: 'Community',
    links: [
      { label: 'Forum', href: '/forum' },
      { label: 'Community gallery', href: '/forum/gallery' },
      { label: 'Create an account', href: '/register' },
      { label: 'Support', href: '/support' },
    ],
  },
  {
    title: 'Project',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Donate', href: '/donate' },
      { label: 'Privacy', href: '/privacy' },
      { label: 'Source code', href: 'https://github.com/ricktek954/newemail' },
      { label: 'Email the team', href: 'mailto:rick@new-email.net' },
    ],
  },
]

export function SiteFooter() {
  return (
    <footer className="bg-sidebar text-sidebar-foreground">
      <div className="mx-auto max-w-7xl px-4 py-16">
        <div className="grid gap-10 md:grid-cols-[1.5fr_repeat(3,1fr)]">
          <div>
            <a href="/" className="flex items-center gap-2">
              <img
                src="/newemail-logo.svg"
                alt="NewEmail logo"
                className="h-10 w-10 rounded-xl shadow-lg"
                width={40}
                height={40}
              />
              <span className="text-lg font-extrabold tracking-tight text-white">
                New<span className="text-[#ff9b65]">Email</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/65">
              A fast, focused desktop inbox for the mail you already use. Local-first,
              standards-based, and built to get out of your way.
            </p>
            <div className="mt-5 flex flex-wrap gap-4 text-sm text-white/65">
              <a
                href="mailto:rick@new-email.net"
                className="inline-flex items-center gap-2 transition-colors hover:text-white"
              >
                <Mail className="h-4 w-4 text-[#ff9b65]" />
                Contact
              </a>
              <a
                href="https://github.com/ricktek954/newemail"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 transition-colors hover:text-white"
              >
                <Code2 className="h-4 w-4 text-[#ff9b65]" />
                GitHub
              </a>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-semibold text-white">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel={link.href.startsWith('http') ? 'noreferrer' : undefined}
                      className="text-sm text-white/65 transition-colors hover:text-white"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-8 text-sm text-white/55 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 NewEmail. Built for making email feel human again.</p>
          <p>Designed and developed by Rick Lopez.</p>
        </div>
      </div>
    </footer>
  )
}
